import * as THREE from 'three';
import type { SeverityKind } from '../types';

const severityColorMap: Record<SeverityKind, string> = {
  info: '#73ffba',
  warn: '#ffbd4a',
  error: '#ff5f86'
};

export const severityHex = (severity: SeverityKind): string => severityColorMap[severity];

export const severityColor = (severity: SeverityKind): THREE.Color =>
  new THREE.Color(severityColorMap[severity]);

export const serviceColor = (serviceName: string): THREE.Color => {
  let hash = 0;
  for (let i = 0; i < serviceName.length; i += 1) {
    hash = serviceName.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;
  return new THREE.Color(`hsl(${hue} 90% 63%)`);
};
